























































import { Component, Vue } from 'vue-property-decorator';
import ConfirmationModal from '@/components/Commons/ConfirmationModal.vue';
import { vxm } from '@/store.vuex';
declare var window: any;

@Component({
  components: {
    ConfirmationModal: ConfirmationModal,
  },
})
export default class DataPrivacySettings extends Vue {
  $wlToastr: any;

  get companyName() {
    return vxm.configs.getGlobalConfigValue('WL_CANDIDATE_PORTAL_APPLICATION_NAME')
  }
  get termsOfServiceURL() {
    return vxm.configs.getCompanyPreference(
      'CANDIDATE_PORTAL_TERMS_OF_SERVICE_END_POINT_URL',
      'termsLink',
    );
  }
  get privacyPolicyURL() {
    return vxm.configs.getCompanyPreference(
      'CANDIDATE_PORTAL_PRIVACY_POLICY_END_POINT_URL',
      'privacyLink',
    );
  }

  get dynamicPrivacyPolicyText(){
    return vxm.configs.getGlobalConfigValue('DYNAMIC_PRIVACY_POLICY_TEXT') ||
     this.$t('dataprivacy-privacy-policy');
  }

  showConfirmation() {
    this.$modal.show(
      ConfirmationModal,
      {
        header: this.$t('DataPrivacySettings_ConfirmRemoval'),
        body: this.$t('DataPrivacySettings_RemovalData',{termsOfServiceURL : this.termsOfServiceURL , privacyPolicyURL : this.privacyPolicyURL}) ,
        // (termsOfServiceURL), (privacyPolicyURL),
        okText: this.$t('dataprivacy-remove-data-btn'),
        cancelText: this.$t('global.cancel-text'),
        onOk: async () => {
          try {
            const response = await vxm.users.removeData();
            if (response && response.meta && response.meta.success) {
              this.$wlToastr('success', response.meta.displayMessage);
              vxm.users.setToken('');
              vxm.users.setRefreshToken('');
              vxm.users.setAuthStatus(false);
              this.$router.push('/findjobs');
            } else {
              this.$wlToastr(
                'error',
                `${this.$t('something.went.wrong')}. ${this.$t('please.try.again')}`,
              );
            }
          } catch (err) {
            const response = err.response;
            if (
              response &&
              response.data &&
              response.data.meta &&
              response.data.meta.error &&
              response.data.meta.error &&
              response.data.meta.error.detailedMessage
            ) {
              this.$wlToastr('error', response.data.meta.error.detailedMessage);
            } else {
              this.$wlToastr(
                'error',
                `${this.$t('something.went.wrong')}. ${this.$t('please.try.again')}`,
              );
            }
          }
        },
        okBtnClass: 'bg-danger',
      },
      {
        height: 'auto',
        clickToClose: false,
      },
    );
  }
  openPrivacyPolicy() {
    window.open(
      vxm.configs.getCompanyPreference(
        'CANDIDATE_PORTAL_PRIVACY_POLICY_END_POINT_URL',
        'privacyLink',
      ),
      '_blank',
    );
  }
  openTermsAndService() {
    window.open(
      vxm.configs.getCompanyPreference(
        'CANDIDATE_PORTAL_TERMS_OF_SERVICE_END_POINT_URL',
        'termsLink',
      ),
      '_blank',
    );
  }
}
